"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TextBlock = TextBlock;
var _react = _interopRequireDefault(require("react"));
var _ = require("../..");
var _Text = require("../../base/Text");
var _animations = require("../../shared/animations");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * Like the `Text` component, except it displays the text within an inline box. Useful for things like
 * highlight or faux-redacting information.
 */
function TextBlock({
  bg,
  css,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_Text.Text, _extends({}, props, {
    css: {
      ...css,
      backgroundColor: bg,
      borderRadius: '$1'
    }
  }));
}

//
// Utility components
// -------------------------------------------------------------------------------------------------

TextBlock.Loadable = Loadable;
function Loadable({
  children,
  loading,
  placeholder,
  ...props
}) {
  const isLoading = (0, _.useLoadable)(loading);
  if (!isLoading) return /*#__PURE__*/_react.default.createElement(_Text.Text, props, children);
  return /*#__PURE__*/_react.default.createElement(TextBlock, _extends({}, props, {
    bg: "$gray300",
    color: "$gray300",
    css: {
      animation: `${_animations.pulse} 1.5s linear infinite`,
      userSelect: 'none'
    }
  }), placeholder !== null && placeholder !== void 0 ? placeholder : children);
}